var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StepComponent',[_c('v-row',[_c('v-col',[_c('LabSelection'),_c('BillingInformation'),_c('GeneralSampleInformation'),_c('SamplingInformation')],1),_c('v-col',[_c('ReviewImages'),_c('PackagesAndComponents'),_c('Price')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }